import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function PoliticaPrivacidade() {
  return (
    <LegalLayout
      testId="privacidade-page"
      title="Política de Privacidade"
      intro="Respeitamos a sua privacidade. Saiba como tratamos as informações que você compartilha com a Inove Tech."
    >
      <Section heading="Dados que coletamos">
        <p>
          Coletamos apenas as informações necessárias para o atendimento, como
          nome, telefone e a descrição do problema do seu aparelho, quando você
          entra em contato conosco.
        </p>
      </Section>

      <Section heading="Como utilizamos">
        <p>
          Utilizamos seus dados exclusivamente para responder ao seu contato,
          realizar o atendimento e prestar o serviço solicitado. Não vendemos
          nem compartilhamos suas informações com terceiros para fins de
          marketing.
        </p>
      </Section>

      <Section heading="Seus direitos">
        <p>
          Você pode solicitar, a qualquer momento, informações sobre os dados
          que temos, bem como a sua correção ou exclusão, entrando em contato
          pelos nossos canais oficiais.
        </p>
      </Section>

      <Section heading="Contato">
        <p>
          Para questões relacionadas à privacidade, fale com a gente pelo
          WhatsApp ou pelo e-mail contato@inovetechvca.com.br.
        </p>
      </Section>
    </LegalLayout>
  );
}
